// extracted by mini-css-extract-plugin
module.exports = {"intro":"PageHome_intro_1z10s","headline":"PageHome_headline_22214","teaser":"PageHome_teaser_2QoVC"};